import { connect } from 'react-redux';
import { createToolbarEvent } from '../../../analytics/AnalyticsEvents';
import { sendAnalytics } from '../../../analytics/functions';
import { translate } from '../../../base/i18n/functions';
import { IconMeter } from '../../../base/icons/svg';
import AbstractButton from '../../../base/toolbox/components/AbstractButton';
import { toggleRenderStats } from '../../actions';
import { isRenderStatsOpen } from '../../functions';
/**
 * Toolbar item that shows/hides the 描画計測 panel: frame rate, long tasks,
 * input latency and page size, for machines where the page as a whole draws
 * slowly.
 *
 * The four are read together on purpose — a low frame rate WITH long tasks is
 * JavaScript, a low frame rate WITHOUT them is the compositor or GPU, and the
 * two have nothing in common but the symptom.
 */
class RenderStatsButton extends AbstractButton {
    accessibilityLabel = 'toolbar.accessibilityRenderStats';
    icon = IconMeter;
    label = 'toolbar.renderStats';
    toggledLabel = 'toolbar.renderStatsOff';
    tooltip = 'toolbar.renderStats';
    /**
     * Toggles the rendering panel.
     *
     * @override
     * @protected
     * @returns {void}
     */
    _handleClick() {
        const { _open, dispatch } = this.props;
        sendAnalytics(createToolbarEvent('perf.renderstats', { enable: !_open }));
        dispatch(toggleRenderStats());
    }
    /**
     * Toggled (ON) while the panel is visible.
     *
     * @override
     * @protected
     * @returns {boolean}
     */
    _isToggled() {
        return this.props._open;
    }
}
/**
 * Maps part of the redux state to the component's props.
 *
 * @param {IReduxState} state - The redux state.
 * @returns {Object}
 */
function mapStateToProps(state) {
    return {
        _open: isRenderStatsOpen(state)
    };
}
export default translate(connect(mapStateToProps)(RenderStatsButton));
